<template>
    <div class="nav-main">
        <ul class="list-unstyled nav">
            <li class="parent-link" data-href="bazis_link">
                <a href="https://bazis.kz" target="_blank">Bazis-A</a>
            </li>
            <li v-for="item in setup.main_page_navigation" class="parent-link" :data-href="item.href">
                <a :href="'https://sales.bazis.kz' + item.href" disabled="disabled" target="_blank">{{item.name}}</a>
                <!-- <router-link :to="item.href" disabled="disabled" @click.native="startLoader(item.href)">{{item.name}}</router-link> -->
                <div class="dropdown-menu" v-if="item.dropdown != false">
                    <ul>
                        <li v-for="link in item.dropdown">
                            <a :href="'https://sales.bazis.kz' + link.href" target="_blank" >{{link.name}}</a>
                            <!-- <router-link :to="link.href" @click.native="startLoader(link.href)">{{link.name}}</router-link> -->
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'nav-main',
        data () {
            return {
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
        }),
        methods: {
            startLoader(name) {
                // console.log(name)
                if (name != '/fine-finish') {
                    this.$parent.$parent.$refs.topProgress.start();
                }
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/nav-main/nav-main.scss';
</style>